<div class="masthead masthead-weekly-report masthead-generic mt-3 mb-3">
    <a
      [routerLink]="['/activity', 'tracker']"
      class="stretched-link"
      tabindex="0"
      ><span class="visually-hidden">Connect Device</span></a
    >
    <div class="masthead-content">
      <h3 class="masthead-title">Connect your Garmin Device</h3>
      <div class="masthead-blurb">
       Get automatic Prep Steps and Prep Fit
        data.
      </div>
      <span class="icon-wrap more-link duo-primary-dark"
        ><fa-icon [icon]="['fad', 'circle-chevron-right']"></fa-icon
      ></span>
    </div>
  </div>